import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/components/ui/dialog';
import { PortalDsButton } from 'src/components/portal-design-system/portal-ds-button';
import { portalDs } from 'src/components/portal-design-system/portal-ds-classes';
import { useCreatePacingBoardMutation } from '../../endpoints/pacing-board.endpoints';

interface PacingBoardCreateModalProps {
  open: boolean;
  onClose: () => void;
  onCreated: (boardId: string) => void;
}

export default function PacingBoardCreateModal({ open, onClose, onCreated }: PacingBoardCreateModalProps) {
  const [name, setName] = useState('');
  const [createBoard, { isLoading }] = useCreatePacingBoardMutation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;
    const board = await createBoard({ name: name.trim() }).unwrap();
    setName('');
    onCreated(board.id);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-md bg-white">
        <DialogHeader>
          <DialogTitle>Create pacing board</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className={portalDs.field}>
            <label className={portalDs.label} htmlFor="board-name">Board name</label>
            <input
              id="board-name"
              className={portalDs.input}
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Q1 2026 budgets"
              autoFocus
            />
          </div>
          <DialogFooter className="mt-6">
            <PortalDsButton variant="ghost" onClick={onClose} type="button">Cancel</PortalDsButton>
            <PortalDsButton variant="accent" type="submit" disabled={isLoading || !name.trim()}>
              Create board
            </PortalDsButton>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
